// Per-user appearance: theme (dark/light) + accent color.
// Prefs live in user_prefs on the server; cached in localStorage so the
// theme applies instantly on load before the API answers.

export const ACCENTS: Record<string, { label: string; main: string; hover: string; soft: string }> = {
  blue:   { label: 'Blue',   main: '#2563eb', hover: '#1d4ed8', soft: '#3b82f6' },
  teal:   { label: 'Teal',   main: '#0d9488', hover: '#0f766e', soft: '#14b8a6' },
  green:  { label: 'Green',  main: '#16a34a', hover: '#15803d', soft: '#22c55e' },
  purple: { label: 'Purple', main: '#7c3aed', hover: '#6d28d9', soft: '#8b5cf6' },
  orange: { label: 'Orange', main: '#ea580c', hover: '#c2410c', soft: '#f97316' },
  rose:   { label: 'Rose',   main: '#e11d48', hover: '#be123c', soft: '#f43f5e' },
};

export interface AppearancePrefs {
  theme?: 'dark' | 'light';
  accent?: string;
}

export function applyAppearance(prefs: AppearancePrefs | null | undefined) {
  const p = prefs || {};
  document.documentElement.dataset.theme = p.theme === 'light' ? 'light' : 'dark';
  const a = ACCENTS[p.accent || 'blue'] ?? ACCENTS.blue;
  const st = document.documentElement.style;
  st.setProperty('--accent', a.main);
  st.setProperty('--accent-hover', a.hover);
  st.setProperty('--accent-soft', a.soft);
  localStorage.setItem('wms_prefs', JSON.stringify(p));
}

export function cachedPrefs(): AppearancePrefs {
  try { return JSON.parse(localStorage.getItem('wms_prefs') || '{}'); }
  catch { return {}; }
}
